<template>
    <div class="flow-distribute flow-container">
        <ParamsHeader></ParamsHeader>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>分布分析</span>
                    <div class="buttons">
                        <el-button icon="el-icon-delete" size="mini" type="success"> 导出数据 </el-button>
                    </div>
                </div>
            </template>
            <div style="padding: 0 20px 20px">
                <ChartMap class="chart-normal" ref="chart"></ChartMap>
            </div>
        </Card>
        <div style="margin-top: 10px; display: flex">
            <div style="flex: 1; border-right: 1px solid #e3e3e3">
                <Card :no-border="false">
                    <template #header>
                        <div class="card-header">
                            <span>客流量TOP5</span>
                            <div class="buttons">
                                <span>单位：人次</span>
                            </div>
                        </div>
                    </template>
                    <el-row class="rank">
                        <el-col :span="8">万达广场</el-col>
                        <el-col :span="4">10000</el-col>
                        <el-col :span="12">
                            <el-progress :show-text="false" :stroke-width="20" :percentage="100" status="exception"></el-progress>
                        </el-col>
                    </el-row>
                </Card>
            </div>
            <div style="flex: 1">
                <Card :no-border="false">
                    <template #header>
                        <div class="card-header">
                            <span>客流量BOTTOM5</span>
                            <div class="buttons">
                                <span>单位：人次</span>
                            </div>
                        </div>
                    </template>
                    <el-row class="rank">
                        <el-col :span="8">万达广场</el-col>
                        <el-col :span="4">10000</el-col>
                        <el-col :span="12">
                            <el-progress :show-text="false" :stroke-width="20" :percentage="100" status="exception"></el-progress>
                        </el-col>
                    </el-row>
                </Card>
            </div>
        </div>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>分布明细</span>
                    <div class="buttons">
                        <el-button size="mini" type="primary" round>按天</el-button>
                        <el-button size="mini" type="primary" round>按周</el-button>
                        <el-button size="mini" type="primary" round>按月</el-button>
                        <el-button icon="el-icon-delete" size="mini" type="success"> 导出数据 </el-button>
                    </div>
                </div>
            </template>
            <list-page :showTitle="false" :api="searchUrl" :searchParam="searchParam" :showPager="true" :showSearch="false" ref="application">
                <el-table-column type="index" width="80px" label="序号"></el-table-column>
                <el-table-column prop="AppName" label="应用名称"></el-table-column>
                <el-table-column prop="TenantName" label="租户"></el-table-column>
                <el-table-column prop="AppAK" label="应用标识(AK)"></el-table-column>
                <el-table-column prop="AppSK" label="应用密钥(SK)"></el-table-column>
                <el-table-column prop="MinInterval" label="接口最小调用间隔（秒）"></el-table-column>
            </list-page>
        </Card>
    </div>
</template>

<script>
import ParamsHeader from "../components/ParamsHeader";
export default {
    name: "flow-distribute",
    components: {
        ParamsHeader,
    },
    data() {
        return {
            searchUrl: "/Platform/GetApps",
            searchParam: {
                Key: "",
            },
        };
    },
    methods: {
        buildChart() {
            let option = this.getOptions();
            this.$refs.chart.setData(option);
        },
        getOptions() {
            let option = {
                color: ["#1080FF", "#FF5679"],
                tooltip: {
                    show: true,
                    showContent: true,
                    trigger: "axis",
                },
                legend: {
                    top: 10,
                    data: ["选择日期", "对比日期"],
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    containLabel: true,
                },
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 100,
                    },
                ],
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    data: ["2020-1", "2020-2", "2020-3", "2020-4", "2020-5", "2020-6", "2020-7", "2020-8", "2020-9", "2020-10", "2020-11", "2020-12"],
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                },
                yAxis: [
                    {
                        type: "value",
                        name: "客流量(人次)",
                    },
                ],
                series: [
                    {
                        name: "选择日期",
                        data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
                        type: "line",
                        smooth: true,
                    },
                    {
                        name: "对比日期",
                        data: [3.9, 5.9, 11.1, 18.7, 48.3, 69.2, 231.6, 46.6, 55.4, 18.4, 10.3, 0.7],
                        type: "line",
                        smooth: true,
                    },
                ],
            };
            return option;
        },
    },
    mounted() {
        this.buildChart();
    },
};
</script>

<style scoped>
.rank {
    padding-right: 20px;
}
.rank :deep(.el-col) {
    padding: 10px 0;
    text-align: center;
}

.rank :deep(.el-col-8) {
    padding: 10px 20px;
    text-align: left;
}
</style>
